/* cpg-fitment-icons.js — extracted 2026-07-16 from sections/product_template.liquid (the 28.1 KB CPG_FITMENT_ICONS IIFE; zero Liquid, verbatim)
 * as part of the core-regulation speed fixes. Loaded with defer (runs after HTML parse,
 * before DOMContentLoaded — identical behavior to the original inline position). */


(function () {
  var CPG_FITMENT_ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    car: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17h14"></path><path d="M5 17a2 2 0 1 1-4 0"></path><path d="M19 17a2 2 0 1 0 4 0"></path><path d="M2 13l2-5a2 2 0 0 1 2-1h12a2 2 0 0 1 2 1l2 5"></path><path d="M2 13h20"></path></svg>',
    warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>',
    globe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v16H4z"></path><path d="m22 6-10 7L2 6"></path></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path></svg>'
  };

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return normalize(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function slugify(value) {
    return normalize(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function moneyText(section) {
    var price = section.querySelector('[data-cpg-price]');
    return price ? normalize(price.textContent) : '';
  }

  function getVariant(section) {
    var variantsScript = section.querySelector('[data-cpg-variants-json]');
    var input = section.querySelector('[data-cpg-variant-id]');
    var variants = [];

    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (error) {}

    if (!variants.length) return null;

    var currentId = input ? String(input.value || '') : '';
    return variants.find(function (variant) {
      return String(variant.id) === currentId;
    }) || variants[0] || null;
  }

  function getSku(section) {
    var widget = section.querySelector('[data-cpg-fitment-state-widget]');
    var variant = getVariant(section);

    if (variant && variant.sku) return String(variant.sku);

    if (widget && widget.getAttribute('data-cpg-current-sku')) {
      return widget.getAttribute('data-cpg-current-sku');
    }

    var skuNode = section.querySelector('.cpg-product__sku');
    return skuNode ? normalize(skuNode.textContent).replace(/^SKU\s*/i, '') : '';
  }

  function getVehicleObject() {
    // CPG teardown: our garage (cpg-ymm-widget.js) is authoritative when present —
    // never fall through to Convermax, or a stale Convermax garage leaks in.
    if (window.CPGFitment) {
      try {
        var cpgVehicle = window.CPGFitment.getVehicle();
        if (cpgVehicle && typeof cpgVehicle === 'object') return cpgVehicle;
      } catch (error) {}
      return null;
    }

    try {
      if (window.Convermax && typeof window.Convermax.getVehicle === 'function') {
        var vehicle = window.Convermax.getVehicle();
        if (vehicle && typeof vehicle === 'object') return vehicle;
      }
    } catch (error) {}

    return null;
  }

  function getVehicleText() {
    if (window.CPGFitment) {
      try { return normalize(window.CPGFitment.getVehicleText()); } catch (error) { return ''; }
    }

    try {
      if (window.Convermax && typeof window.Convermax.isVehicleSelected === 'function' && !window.Convermax.isVehicleSelected()) {
        return '';
      }
    } catch (error) {}

    try {
      if (window.Convermax && typeof window.Convermax.getVehicleString === 'function') {
        var text = normalize(window.Convermax.getVehicleString());
        if (text) return text;
      }
    } catch (error) {}

    var vehicle = getVehicleObject();

    if (vehicle) {
      var parts = [
        vehicle.year || vehicle.Year || vehicle.YMM_Year,
        vehicle.make || vehicle.Make || vehicle.YMM_Make,
        vehicle.model || vehicle.Model || vehicle.YMM_Model,
        vehicle.submodel || vehicle.Submodel || vehicle.trim || vehicle.Trim || vehicle.YMM_Submodel,
        vehicle.engine || vehicle.Engine || vehicle.YMM_Engine,
        vehicle.drivetrain || vehicle.Drivetrain || vehicle.YMM_Drivetrain
      ].filter(Boolean);

      if (parts.length) return normalize(parts.join(' '));
    }

    var node = document.querySelector('.garage-item .select-model, [data-cm-role="select-vehicle"], .cm_garage .select-model, .cm_vehicle-widget_header-label');
    return node ? normalize(node.textContent) : '';
  }

  function isVehicleSelected() {
    if (window.CPGFitment) {
      try { return Boolean(window.CPGFitment.hasVehicle()); } catch (error) { return false; }
    }

    try {
      if (window.Convermax && typeof window.Convermax.isVehicleSelected === 'function') {
        return Boolean(window.Convermax.isVehicleSelected());
      }
    } catch (error) {}

    return Boolean(getVehicleText());
  }

  function getVehicleId() {
    var vehicle = getVehicleObject();

    if (vehicle) {
      var direct = vehicle.vehicleId || vehicle.id || vehicle.ID || vehicle.VehicleID || vehicle.vehicle_id || vehicle.fitmentId || vehicle.fitment_id;
      if (direct) return String(direct);

      var parts = [
        vehicle.year || vehicle.Year || vehicle.YMM_Year,
        vehicle.make || vehicle.Make || vehicle.YMM_Make,
        vehicle.model || vehicle.Model || vehicle.YMM_Model,
        vehicle.submodel || vehicle.Submodel || vehicle.trim || vehicle.Trim || vehicle.YMM_Submodel,
        vehicle.engine || vehicle.Engine || vehicle.YMM_Engine
      ].filter(Boolean);

      if (parts.length) return slugify(parts.join('-'));
    }

    return slugify(getVehicleText());
  }

  function getFallbackState(section) {
    var status = section.getAttribute('data-cpg-fitment-status') || '';

    if (!isVehicleSelected()) return { fitmentState: 'no_vehicle', vehicle: null, match: null, missingFields: [] };
    if (status === 'fit') return { fitmentState: 'confirmed', vehicle: vehicleFromText(getVehicleText()), match: defaultMatch(true), missingFields: [] };
    if (status === 'not-fit') return { fitmentState: 'no_fit', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [], alternativesCount: 0 };
    if (status === 'universal') return { fitmentState: 'universal', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [] };
    if (status === 'build-spec') return { fitmentState: 'build-spec', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [] };
    if (status === 'no-data') return { fitmentState: 'unverified', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [] };
    if (status === 'partial') return { fitmentState: 'likely_fits', vehicle: vehicleFromText(getVehicleText()), match: defaultMatch(null), missingFields: ['engine'] };

    var confirmed = section.querySelector('[data-cpg-fitment-confirmed]:not([hidden]), [data-cpg-fitment-card]:not([hidden])');
    var notFit = section.querySelector('[data-cpg-fitment-not-fit]:not([hidden]), [data-cpg-not-fit-card]:not([hidden])');
    var noData = section.querySelector('[data-cpg-fitment-no-data]:not([hidden]), [data-cpg-no-fitment-data-card]:not([hidden])');

    if (confirmed) return { fitmentState: 'confirmed', vehicle: vehicleFromText(getVehicleText()), match: defaultMatch(true), missingFields: [] };
    if (notFit) return { fitmentState: 'no_fit', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [] };
    if (noData) return { fitmentState: 'unverified', vehicle: vehicleFromText(getVehicleText()), match: null, missingFields: [] };

    return { fitmentState: 'likely_fits', vehicle: vehicleFromText(getVehicleText()), match: defaultMatch(null), missingFields: ['engine'] };
  }

  function getReliableLocalState(section) {
    var status = section.getAttribute('data-cpg-fitment-status') || '';
    var vehicle = vehicleFromText(getVehicleText());

    if (!isVehicleSelected()) {
      return { fitmentState: 'no_vehicle', vehicle: null, match: null, missingFields: [] };
    }

    if (status === 'fit') {
      return { fitmentState: 'confirmed', vehicle: vehicle, match: defaultMatch(true), missingFields: [] };
    }

    if (status === 'not-fit') {
      return { fitmentState: 'no_fit', vehicle: vehicle, match: null, missingFields: [], alternativesCount: 0 };
    }

    if (status === 'universal') {
      return { fitmentState: 'universal', vehicle: vehicle, match: null, missingFields: [] };
    }

    if (status === 'build-spec') {
      return { fitmentState: 'build-spec', vehicle: vehicle, match: null, missingFields: [] };
    }

    if (status === 'no-data') {
      return { fitmentState: 'unverified', vehicle: vehicle, match: null, missingFields: [] };
    }

    if (status === 'partial') {
      return { fitmentState: 'likely_fits', vehicle: vehicle, match: defaultMatch(null), missingFields: ['engine'] };
    }

    return null;
  }

  function waitForReliableLocalState(section, timeout) {
    return new Promise(function (resolve) {
      var started = Date.now();

      function check() {
        var result = getReliableLocalState(section);

        if (result) {
          resolve(result);
          return;
        }

        if (Date.now() - started >= timeout) {
          resolve(null);
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function defaultMatch(value) {
    return {
      year: true,
      make_model: true,
      submodel: true,
      engine: value,
      drivetrain: true
    };
  }

  function vehicleFromText(text) {
    return {
      label: normalize(text || 'your selected vehicle')
    };
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) return '';

    if (vehicle.label) return normalize(vehicle.label);

    return normalize([
      vehicle.year,
      vehicle.make,
      vehicle.model,
      vehicle.submodel,
      vehicle.engine,
      vehicle.drivetrain
    ].filter(Boolean).join(' '));
  }

  function shortVehicleLabel(vehicle) {
    if (!vehicle) return 'your vehicle';

    // MOCKUP 2026-10-02 (owner): always name the full vehicle incl. trim + engine.
    var parts = [vehicle.year, vehicle.make, vehicle.model, vehicle.submodel, vehicle.engine].filter(Boolean);

    if (parts.length) return normalize(parts.join(' '));

    return vehicleLabel(vehicle) || 'your vehicle';
  }

  function row(label, value, className) {
    return '<div class="cpg-fit-state__row"><span>' + escapeHtml(label) + '</span><strong class="' + (className || '') + '">' + value + '</strong></div>';
  }

  function matchValue(value, positiveText, missingText) {
    if (value === true) return '<strong class="is-match">' + escapeHtml(positiveText || 'Matched') + ' ✓</strong>';
    if (value === false) return '<strong class="is-error">Mismatch</strong>';
    return '<strong class="is-missing">' + escapeHtml(missingText || 'Not specified by manufacturer') + '</strong>';
  }

  function header(type, icon, eyebrow, title) {
    return '<div class="cpg-fit-state__head cpg-fit-state__head--' + type + '">' +
      '<span class="cpg-fit-state__icon">' + CPG_FITMENT_ICONS[icon] + '</span>' +
      '<span><span class="cpg-fit-state__eyebrow">' + escapeHtml(eyebrow) + '</span>' +
      '<span class="cpg-fit-state__title">' + title + '</span></span>' +
      '</div>';
  }

  function specsFromResponse(data) {
    var vehicle = data.vehicle || {};
    var match = data.match || {};
    var html = '<div class="cpg-fit-state__specs">';

    if (vehicle.year || match.year !== undefined) {
      html += row('Year', matchValue(match.year, vehicle.year || 'Matched'), '');
    }

    if (vehicle.make || vehicle.model || match.make_model !== undefined) {
      html += row('Make / Model', matchValue(match.make_model, normalize([vehicle.make, vehicle.model].filter(Boolean).join(' ')) || 'Matched'), '');
    }

    if (vehicle.submodel || match.submodel !== undefined) {
      html += row('Submodel', matchValue(match.submodel, vehicle.submodel || 'All trims'), '');
    }

    if (vehicle.engine || match.engine !== undefined) {
      html += row('Engine', matchValue(match.engine, vehicle.engine || 'Matched'), '');
    }

    if (vehicle.drivetrain || match.drivetrain !== undefined) {
      html += row('Drivetrain', matchValue(match.drivetrain, vehicle.drivetrain || 'Matched'), '');
    }

    html += '</div>';
    return html;
  }

  function noVehicleTemplate() {
    return { html: '', showSelector: true, hasContent: false };
  }

  function confirmedTemplate(section, data) {
    var vehicle = vehicleLabel(data.vehicle) || getVehicleText() || 'your vehicle';
    // No Add to Cart here (owner rule 2026-07-21): the fit card is informational
    // trust UI only — the ONE buy action is the standard qty+ATC row below it.
    var html = header('confirmed', 'check', 'Confirmed Fit', 'Fits ' + escapeHtml(vehicle)) +
      '<div class="cpg-fit-state__body">' +
      specsFromResponse(data) +
      '</div>';

    return { html: html, showSelector: false, hasContent: true };
  }

  function likelyTemplate(section, data) {
    var vehicle = shortVehicleLabel(data.vehicle);
    var price = moneyText(section);
    var missingFields = Array.isArray(data.missingFields) && data.missingFields.length ? data.missingFields.join(', ') : 'some fitment details';
    var html = header('likely', 'warn', 'Likely Fits', 'Matches your ' + escapeHtml(vehicle) + ', verify before ordering') +
      '<div class="cpg-fit-state__body">' +
      specsFromResponse(data) +
      '<div class="cpg-fit-state__note"><strong>Why this matters:</strong> ' + escapeHtml(missingFields) + ' is missing from the manufacturer fitment data. We recommend confirming before ordering.</div>' +
      '<div class="cpg-fit-state__actions">' +
      '<a class="cpg-fit-state__button cpg-fit-state__button--amber" href="/pages/contact-us?ref=fitment&vehicle=' + encodeURIComponent(vehicle) + '&sku=' + encodeURIComponent((window.CPG_PT_DATA||{}).currentVariantSku||'') + '&product=' + encodeURIComponent((window.CPG_PT_DATA||{}).productTitle||'') + '">' + CPG_FITMENT_ICONS.phone + ' Verify Fit with Expert (Free)</a>' +
      '</div>' +
      '</div>';

    return { html: html, showSelector: false, hasContent: true };
  }

  function universalTemplate(section, data) {
    var html = header('universal', 'globe', 'Universal Fit', 'Works with most vehicles. Check the specs.') +
      '<div class="cpg-fit-state__body">' +
      '<p>This part is not vehicle specific. It is built to fit many vehicles rather than one, so we cannot guarantee it will fit yours. Please check the specifications and measurements against your vehicle before adding it to your cart. Confirming fit is the responsibility of the customer.</p>' +
      '</div>';

    return { html: html, showSelector: false, hasContent: true };
  }

  function buildSpecTemplate(section, data) {
    var html = header('universal', 'globe', 'Sold by Specification', 'Engine build part, chosen by measurements') +
      '<div class="cpg-fit-state__body">' +
      '<p>This is an engine build and performance part. It is selected by its measurements, not by year, make and model. Match the specifications to your build to be sure it is right for you. If you are not certain, we recommend confirming with your mechanic or dealership before ordering. Confirming fit is the responsibility of the customer.</p>' +
      '<p style="margin-top:8px;font-size:12.5px;opacity:.85;">Full specifications are listed in the Description tab below.</p>' +
      '</div>';

    return { html: html, showSelector: false, hasContent: true };
  }

  function unverifiedTemplate(section, data) {
    var vehicle = shortVehicleLabel(data.vehicle);
    var price = moneyText(section);
    var html = header('unverified', 'info', 'Fitment Unverified', 'Let us confirm this fits your ' + escapeHtml(vehicle)) +
      '<div class="cpg-fit-state__body">' +
      '<p>We do not have manufacturer fitment data for this part yet. Our team can verify compatibility with your <strong>' + escapeHtml(vehicle) + '</strong>.</p>' +
      '<div class="cpg-fit-state__support">' +
      '<div class="cpg-fit-state__support-title">Get Fitment Confirmed</div>' +
      '<div class="cpg-fit-state__support-row">' + CPG_FITMENT_ICONS.mail + '<strong>Email reply</strong> within 2 hours</div>' +
      '<div class="cpg-fit-state__support-row">' + CPG_FITMENT_ICONS.chat + '<strong>Live chat</strong> during business hours</div>' +
      '<div class="cpg-fit-state__support-row">' + CPG_FITMENT_ICONS.phone + '<strong>Call +1 (210) 645-5510</strong></div>' +
      '</div>' +
      '<div class="cpg-fit-state__actions">' +
      '<a class="cpg-fit-state__button cpg-fit-state__button--primary" href="/pages/contact-us?ref=fitment&vehicle=' + encodeURIComponent(vehicle) + '&sku=' + encodeURIComponent((window.CPG_PT_DATA||{}).currentVariantSku||'') + '&product=' + encodeURIComponent((window.CPG_PT_DATA||{}).productTitle||'') + '">Verify Fit for My Vehicle (Free)</a>' +
      '</div>' +
      '</div>';

    return { html: html, showSelector: false, hasContent: true };
  }

  function noFitTemplate(section, data) {
    var vehicle = shortVehicleLabel(data.vehicle);
    var count = Number(data.alternativesCount || 0);
    var designedFor = data.designedFor || {};
    var html = header('no-fit', 'x', 'Does Not Fit', 'Not compatible with your ' + escapeHtml(vehicle)) +
      '<div class="cpg-fit-state__body">' +
      '<p>This product is not compatible with your selected vehicle.</p>';

    if (designedFor || data.alternativesCount) {
      html += '<div class="cpg-fit-state__specs">';
      if (designedFor && (designedFor.year || designedFor.make || designedFor.model || designedFor.engine)) {
        html += row('Designed for', escapeHtml(normalize([designedFor.year, designedFor.make, designedFor.model, designedFor.engine].filter(Boolean).join(' '))), '');
      }
      html += row('Your vehicle', escapeHtml(vehicle), '');
      if (data.match && data.match.engine === false) html += row('Engine', 'Mismatch', 'is-error');
      html += '</div>';
    }

    // Always give a way forward — never a dead end. Primary CTA takes the
    // shopper to the parts that DO fit their vehicle; secondary lets them
    // switch vehicle right here.
    html += '<div class="cpg-fit-state__actions">';
    html += '<button type="button" class="cpg-fit-state__button cpg-fit-state__button--primary" data-cpg-fit-state-find-parts>' +
      CPG_FITMENT_ICONS.search + (count > 0 ? ' Show ' + count + ' Parts That Fit' : ' Shop Parts That Fit Your ' + escapeHtml(vehicle)) + '</button>';
    html += '<button type="button" class="cpg-fit-state__button cpg-fit-state__button--outline" data-cpg-fit-state-change>Change Vehicle</button>';
    html += '</div></div>';
    return { html: html, showSelector: false, hasContent: true };
  }

  // The active garage vehicle scopes the destination to exactly what fits the
  // shopper. CATEGORY NARROWING (2026-08-17): route to the part's OWN canonical
  // category, not the whole catalog, so a not-fitting muffler lands the shopper
  // on mufflers that fit their vehicle. The old data-cpg-main-category metafield
  // holds RAW SEMA terms ("Air and Fuel Delivery") that never matched the
  // canonical taxonomy — so instead we read data-cpg-fit-cat-url, which the
  // product template resolves server-side from the product's canonical `cat:`
  // tags via cpg.category_menu (the collection page reads the same vehicle
  // params + garage). Falls back to Shop All when no category resolved.
  function runConvermaxFindParts(section) {
    var params = [];
    // Explicit vehicle params (the collection/Shop All page also auto-scopes off
    // the garage — this makes the landing deterministic and the URL shareable).
    try {
      var v = JSON.parse(localStorage.getItem('cpg:garage:vehicle'));
      if (v && v.year && v.make && v.model) {
        params.push('year=' + encodeURIComponent(v.year));
        params.push('make=' + encodeURIComponent(v.make));
        params.push('model=' + encodeURIComponent(v.model));
      }
    } catch (e) { /* garage unreadable — land unscoped */ }
    var catUrl = section && section.getAttribute('data-cpg-fit-cat-url');
    var base = (catUrl && catUrl.charAt(0) === '/') ? catUrl : '/pages/shop-all';
    window.location.href = base + (params.length ? '?' + params.join('&') : '');
  }

  function checkingTemplate() {
    return {
      html:
        '<div class="cpg-fit-state cpg-fit-state--checking">' +
          '<div class="cpg-fit-state__head">' +
            '<span class="cpg-fit-state__icon" aria-hidden="true">↻</span>' +
            '<div>' +
              '<div class="cpg-fit-state__eyebrow">Fitment Check</div>' +
              '<div class="cpg-fit-state__title">Checking compatibility…</div>' +
            '</div>' +
          '</div>' +
        '</div>',
      showSelector: false,
      hasContent: true
    };
  }

  function renderState(section, data) {
    var widget = section.querySelector('[data-cpg-fitment-state-widget]');
    var box = section.querySelector('[data-cpg-ymm-box]');

    if (!widget || !box) return;

    var state = data && data.fitmentState ? data.fitmentState : 'no_vehicle';
    var rendered;

    if (state === 'checking') rendered = checkingTemplate();
    else if (state === 'confirmed') rendered = confirmedTemplate(section, data);
    else if (state === 'likely_fits') rendered = likelyTemplate(section, data);
    else if (state === 'universal') rendered = universalTemplate(section, data);
    else if (state === 'build-spec') rendered = buildSpecTemplate(section, data);
    else if (state === 'unverified') rendered = unverifiedTemplate(section, data);
    else if (state === 'no_fit') rendered = noFitTemplate(section, data);
    else rendered = noVehicleTemplate();

    widget.innerHTML = rendered.html;
    box.setAttribute('data-cpg-state-show-selector', state === 'no_vehicle' ? 'true' : 'false');
    box.setAttribute('data-cpg-state-has-content', rendered.hasContent ? 'true' : 'false');
    section.setAttribute('data-cpg-api-fitment-state', state);

    try {
      document.dispatchEvent(new CustomEvent('cpgApiFitmentStateChanged', {
        detail: {
          sectionId: section.id,
          fitmentState: state,
          vehicle: data && data.vehicle ? data.vehicle : '',
          vehicleText: data && data.vehicleText ? data.vehicleText : shortVehicleLabel(data && data.vehicle ? data.vehicle : '')
        }
      }));
    } catch (error) {}
  }

  function fetchFitment(section) {
    var widget = section.querySelector('[data-cpg-fitment-state-widget]');
    if (!widget) return Promise.resolve(getFallbackState(section));

    if (!isVehicleSelected()) return Promise.resolve({ fitmentState: 'no_vehicle', vehicle: null, match: null, missingFields: [] });

    // CPG teardown: verify against OUR fitment API (via the CPGFitment adapter)
    // instead of the never-built /api/fitment-check endpoint.
    if (window.CPGFitment && typeof window.CPGFitment.verify === 'function') {
      var cpgVehicle = getVehicleObject();
      var cpgProductId = window.CPG_PT_DATA && window.CPG_PT_DATA.productId;

      return window.CPGFitment.verify(cpgProductId).then(function (status) {
        if (status === 'fit') {
          return {
            fitmentState: 'confirmed',
            vehicle: cpgVehicle,
            vehicleText: getVehicleText(),
            match: {
              year: true,
              make_model: true,
              submodel: cpgVehicle && cpgVehicle.submodel ? true : undefined,
              engine: cpgVehicle && cpgVehicle.engine ? true : undefined
            },
            missingFields: []
          };
        }
        if (status === 'not-fit') {
          return { fitmentState: 'no_fit', vehicle: cpgVehicle, match: null, missingFields: [], alternativesCount: 0 };
        }
        if (status === 'no-data') {
          return { fitmentState: 'unverified', vehicle: cpgVehicle, match: null, missingFields: [] };
        }
        return null; // 'error' → caller falls back to the local-state path
      });
    }

    var endpoint = widget.getAttribute('data-cpg-fitment-api-endpoint') || '/api/fitment-check';
    var sku = getSku(section);
    var vehicleId = getVehicleId();

    if (!sku || !vehicleId) return Promise.resolve(getFallbackState(section));

    var url = endpoint + '?sku=' + encodeURIComponent(sku) + '&vehicleId=' + encodeURIComponent(vehicleId);

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 2200);

    return fetch(url, {
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Fitment API unavailable');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.fitmentState) throw new Error('Invalid fitment API response');
        return data;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        window.clearTimeout(timeoutId);
      });
  }

  function updateWidget(section, force) {
    window.clearTimeout(section._cpgApiFitmentTimer);

    section._cpgApiFitmentTimer = window.setTimeout(function () {
      var selected = isVehicleSelected();
      var signature = [selected ? '1' : '0', getSku(section), getVehicleId()].join('|');

      if (!force && section._cpgLastFitmentSignature === signature) return;
      section._cpgLastFitmentSignature = signature;

      if (!selected) {
        renderState(section, {
          fitmentState: 'no_vehicle',
          vehicle: null,
          match: null,
          missingFields: []
        });
        return;
      }

      /*
        Never guess that the part fits. Show a short checking state, then render
        the first reliable result returned by the API or Convermax.
      */
      renderState(section, {
        fitmentState: 'checking',
        vehicle: vehicleFromText(getVehicleText())
      });

      Promise.all([
        fetchFitment(section),
        waitForReliableLocalState(section, 1900)
      ]).then(function (results) {
        if (section._cpgLastFitmentSignature !== signature) return;

        var apiResult = results[0];
        var localResult = results[1];
        var finalResult = apiResult || localResult;

        if (!finalResult) {
          finalResult = {
            fitmentState: 'unverified',
            vehicle: vehicleFromText(getVehicleText()),
            match: null,
            missingFields: []
          };
        }

        renderState(section, finalResult);
      });
    }, 80);
  }

  function initProductFitmentStateWidgets() {
    document.querySelectorAll('[data-cpg-product-section]').forEach(function (section) {
      var widget = section.querySelector('[data-cpg-fitment-state-widget]');
      if (!widget) return;

      updateWidget(section);

      if (widget.getAttribute('data-cpg-state-bound') === 'true') return;

      widget.setAttribute('data-cpg-state-bound', 'true');

      widget.addEventListener('click', function (event) {
        if (event.target.closest('[data-cpg-fit-state-add-cart]')) {
          event.preventDefault();

          var addButton = section.querySelector('.cpg-product__add, button[name="add"], [type="submit"][name="add"]');
          if (addButton) addButton.click();
        }

        if (event.target.closest('[data-cpg-fit-state-find-parts]')) {
          event.preventDefault();
          runConvermaxFindParts(section);
        }

        if (event.target.closest('[data-cpg-fit-state-change]')) {
          event.preventDefault();
          if (window.CPGFitFlow && typeof window.CPGFitFlow.openStepper === 'function') {
            window.CPGFitFlow.openStepper();
          } else if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
            window.CPGFitment.openPicker();
          }
        }
      });

      var events = [
        'vehicleSelected',
        'vehicleChanged',
        'vehicleDiscarded',
        'garageChanged',
        'fitmentChanged',
        'convermax:vehicle-selected',
        'convermax:vehicle-changed',
        'convermax:vehicle-discarded',
        'convermax:garage-changed',
        'variant:change'
      ];

      events.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          updateWidget(section);
          window.setTimeout(function () { updateWidget(section); }, 700);
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest('.cm_garage, .cm_garageDropdown, .cm_vehicle-widget, [data-cm-role], [class*="garage"], [class*="Garage"]')) {
          updateWidget(section);
          window.setTimeout(function () { updateWidget(section); }, 300);
          window.setTimeout(function () { updateWidget(section); }, 900);
          window.setTimeout(function () { updateWidget(section); }, 1800);
        }
      }, true);

      section.addEventListener('click', function (event) {
        if (event.target.closest('[data-cpg-option-value], [data-cpg-sticky-add], .cpg-product__add, .cm_vehicle-widget_button, .cm_button, .cm-btn, .cm_vehicle-widget_header')) {
          updateWidget(section);
          window.setTimeout(function () { updateWidget(section); }, 700);
          window.setTimeout(function () { updateWidget(section); }, 1800);
        }
      }, true);

      section.addEventListener('change', function (event) {
        if (event.target.closest('select, input, [data-cpg-variant-id]')) {
          updateWidget(section);
          window.setTimeout(function () { updateWidget(section); }, 700);
        }
      }, true);

      window.addEventListener('storage', function () {
        updateWidget(section);
      });

      if (window.MutationObserver) {
        var vehicleHost = section.querySelector('.cpg-product__ymm-widget-wrap');

        if (vehicleHost) {
          var observer = new MutationObserver(function (mutations) {
            var relevant = mutations.some(function (mutation) {
              var target = mutation.target;
              return !target.closest || !target.closest('[data-cpg-fitment-state-widget]');
            });

            if (relevant) updateWidget(section);
          });

          observer.observe(vehicleHost, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value', 'class', 'aria-selected']
          });
        }
      }

      // CPG teardown: our YMM widget announces garage changes — refresh instantly.
      window.addEventListener('cpg:vehicle-changed', function () {
        updateWidget(section, true);
      });

      /*
        Lightweight safety check only. Signature protection prevents duplicate
        work and repeated API requests.
      */
      window.setInterval(function () {
        updateWidget(section);
      }, 5000);
    });
  }

  /* CPG fix 2026-07-23: the old capture-phase hijack that sent every
     [data-cpg-fit-state-find-parts] click to /collections/ (killing the real
     handler) has been removed — runConvermaxFindParts owns the click now. */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFitmentStateWidgets);
  } else {
    initProductFitmentStateWidgets();
  }

  document.addEventListener('shopify:section:load', initProductFitmentStateWidgets);
})();
